<template>
  <v-app>
    <router-view />
    <update-wrapper />
  </v-app>
</template>

<script>
import UpdateWrapper from './components/UpdateDialog.vue'

export default {
  name: 'App',
  components: {
    UpdateWrapper
  },

  data: () => ({
  }),
  localStorage: {
    email: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: {
        authenticated: false,
        email: '',
        name: '',
        picture: '',
        token: '',
        role: ''
      }
    },
    reliable: {
      type: Boolean,
      default: false
    }
  }
}
</script>
